<template>
  <div class="d-flex">
    <div class="card-content">
      <div class="card-content-item">
        <div class="card-content-result">
          <div class="card-content-title">
            <strong><Skeleton width="50px" height="25px" /></strong>
          </div>
          <!-- <div>
            <span><Skeleton width="120px" height="20px" /></span>
          </div>
          <div class="hr">
            <Hr />
          </div> -->
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="title">
        <div>
          <div>
            <div><Skeleton width="180px" height="15px" /></div>
            <div><Skeleton width="120px" height="15px" /></div>
          </div>
        </div>
      </div>
      <div class="button">
        <Skeleton width="120px" height="30px" />
      </div>
    </div>
  </div>
</template>

<script>
import { Hr } from '@n11/so-ui-components';
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'AdSummarySkeleton',
  components: {
    Hr,
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
.card-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;

  &-item {
    width: 48%;
  }

  &-title {
    display: flex;
    justify-content: space-between;
  }

  &-result {
    strong {
      display: block;
      margin-right: 8px;
      margin-bottom: 6px;
    }

    span {
      display: block;
    }
  }
}

.card-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .title {
    width: 65%;
    display: flex;
  }

  .button {
    display: flex;
    justify-content: flex-end;
  }
}

.hr {
  margin: 10px 0;
}
</style>
